import React, { useEffect } from 'react';
import { useFormik } from 'formik';

// MUI
import { Box, TextField, Grid, Modal, Divider, Typography, IconButton, Button, Stack } from '@mui/material';
import { Close } from '@mui/icons-material';

// COMPONENTS
import UploadSingleFile from '@components/Files/UploadSingleFile';

// VALIDATION & INTERFACE
import { PlantillaSchema } from '@data/schemas/EventosSchemas';
import { PlantillasInterface } from '@data/interfaces/EventosInterfaces';

const FormTemplateQR = (props) => {
  const {
    setModalOpen,
    modalOpen,
    params = {},
    title = 'Actualización de información',
    setData,
    idTipo,
  } = props;

  const formik = useFormik({
    initialValues: { ...PlantillasInterface, idTipo },
    validationSchema: PlantillaSchema,
    enableReinitialize: false,
    onSubmit: (values) => {
      setData(values);
    },
  });

  const resetParams = () => {
    formik.resetForm();
    setModalOpen(false);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    if (Object.keys(params).length > 0) {
      formik.setValues({
        id: params.id || '',
        Titulo: params.Titulo || '',
        idTipo: params.idTipo || idTipo,
        files: [{ file: params.RutaImagen }],
      });
    }
    //eslint-disable-next-line
  }, [params]);

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="modal-template-title"
      aria-describedby="modal-template-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '95%',
          maxWidth: 600,
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography id="modal-template-title" variant="h6" fontWeight="bold">
            {title}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="Titulo"
              label="Título de la plantilla"
              variant="outlined"
              size="small"
              fullWidth
              value={formik.values.Titulo}
              onChange={(e) => formik.setFieldValue('Titulo', e.target.value)}
              error={Boolean(formik.errors.Titulo)}
              helperText={formik.errors.Titulo}
            />
          </Grid>

          <Grid item xs={12}>
            <UploadSingleFile
              file={
                formik.values.files && formik.values.files.length > 0
                  ? formik.values.files[0].file
                  : params.RutaImagen
              }
              setFile={(e) =>
                formik.setValues((prev) => ({
                  ...prev,
                  files: [{ file: e }],
                }))
              }
              accept="image/*"
            />
            {formik.errors?.files && Array.isArray(formik.errors.files) && formik.errors.files[0]?.file && (
              <Typography color="error" variant="body2" mt={1}>
                {formik.errors.files[0].file}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" color="error" onClick={resetParams}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={formik.submitForm}>
            Guardar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default FormTemplateQR;
